<template>
    <div class="multiple-filters-container">
        <component 
            v-for="(filter, index) in filters" 
            :key="index"
            :is="filter.component"
            v-bind="filter.props"
        />
    </div>
</template>

<script>
    export default {
        props: {
            filters: {
                type: Array,
                default: () => []
            }
        }
    }
</script>

<style scoped>
    .multiple-filters-container {
        display: flex;
        gap: 10px;
        align-items: center;
    }
</style>